import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { NavLink } from "react-router-dom";
import LabeledFrame from 'components/LabeledFrame';
import { openPopupWindow } from 'helpers/generic';

const TableContracts = styled.table`
	font-size: 12px;
	margin-bottom: 0;

	thead {
		tr {
			th {
				font-weight: 600;

				&:first-of-type {
					width: 100px !important;
				}
			}
		}
	}

	tbody {
		border-top-color: var(--bs-gray-400) !important;

		tr {
			td {
				border-bottom-width: 0;

				&:first-of-type {
					width: 100px !important;
				}
			}
		}
	}
`;

let axiosCancelToken = null;

export default function Contracts(props) {
    let [contracts, setContracts] = useState([]);

    useEffect(() => {
		axiosCancelToken = axios.CancelToken.source();
	
		return function cleanup() {
           	axiosCancelToken.cancel();
        }
	}, []);

    useEffect(() => {
        if ( !props.community_id ) return;
        
        axios.get('/api/manager/contracts/list', {
            params: {
                community_id: props.community_id,
                no_paginate: true,
            },
            cancelToken: axiosCancelToken.token
        }).then((response) => {
            setContracts([...response.data]);
        }).catch((error) => {
            if ( axios.isCancel(error) ) return;
        });
    }, [props.community_id]);


	const openPopupInfoWindow = (e) => {
		e.preventDefault();

		openPopupWindow(e.currentTarget.href);
	}

    contracts = contracts?.filter(el => el.status);

	return (
        <React.Fragment>
            { contracts?.length > 0 &&
                <LabeledFrame className="mb-3" label="Contratos activos">
                    <TableContracts className="table table-sm">
                        <thead>
                            <tr>
                                <th>Proveedor</th>
                                <th>Nº de contrato</th>
                            </tr>
                        </thead>
                        <tbody>
                            {contracts?.map((el, idx) => {
                                if ( !el.status ) return null;

                                return (
                                    <tr key={idx}>
                                        <td>
                                            {el.provider.business_name}
                                            <NavLink to={'/providers/edit/' + el.provider_id + '?popup=true'} onClick={(e) => openPopupInfoWindow(e)}><i className="bi bi-eye-fill"></i></NavLink>
                                        </td>
                                        <td>
                                            {el.number} 
                                            <NavLink to={'/contracts/edit/' + el.id + '?community_id='+(props.community_id ?? '')+'&popup=true'} onClick={(e) => openPopupInfoWindow(e)}><i className="bi bi-eye-fill"></i></NavLink>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </TableContracts>
                </LabeledFrame>
            }
        </React.Fragment>
	);
}